/**
 * Condition to check if time is set on military time
 * Maximum allowed time 2359
 * Minimum allowed time 0000
 * If value length is <=1, number should between [0, 2]
 * If value length is === 2, number should be less than 24 to meet maximum allowed time
 * If value length is === 3, third number should be 5 or less to meet maximum allowed time
 * If value lenght is === 4, all numbers are allowed
 * Number should be positive
 */
export function isMilitaryTime(value) {
  const valueLength = value.length
  const parsedValue = Number(value)

  return (
    ((valueLength <= 1 && parsedValue < 3) ||
      (valueLength === 2 && parsedValue < 24) ||
      (valueLength === 3 && Number(value[2]) < 6) ||
      valueLength === 4) &&
    parsedValue >= 0 &&
    parsedValue <= 2359
  )
}
